export default __webpack_public_path__ + "assets/linkedin-logo.85f850a5.png";